import { base_url } from './url';

export const getAssignedUrl = async(userId, taskId, extension) => {
  const response = await fetch(`${base_url}/digiact-gcs-signed-url`, { method: 'POST',
    body: JSON.stringify({ file_name: `${userId}_t${taskId}${extension}` }),
    headers:{'Content-Type':"application/json"} });
  const data = await response.text();
  return data;
  
  // return data;
}

export const uploadFile = async(storageLink, video_file) => {
  const {data} = await fetch(storageLink, {method:'PUT', body: video_file, headers:{'Content-Type': 'binary/octet-stream' }});
  return data;
}

export const uploadVideoMetadata = async(userId, taskId, extension) => {
  const file_name = `${userId}t${taskId}.${extension}`
  const { data } = await fetch(`${base_url}/digiact-video-upload`, {
    method: 'POST',
    body: {
      user_id: userId,
      task_id: taskId,
      video_paths: [file_name]
    }
  });
  return data;
}
